/* =====================================================
   Header Component – Version 2.1 (Modified: July 31, 2025)
   Displays game title and target number
   Date Modified: 31 July 2025 | Time: Current
===================================================== */

import { useGameState } from '../hooks/useGameState'
import styles from './Header.module.css'

/**
 * Header component displaying game title and target number
 */
function Header() {
  const { TARGET } = useGameState()

  return (
    <header className={styles.topPanel}>
      <h1 className={styles.title}>
        <span className={styles.gameTitle}>🔢 Numdle</span>
        <span className={styles.target}>
          {TARGET}
         </span>
     <a
          className={styles.helpButton}
          href="https://portal.numdle.co.uk/numdle"
          target="_blank"
          rel="noopener noreferrer"
        >
          Help
        </a>
       </h1>
   </header>
  )
}


export default Header
